<section class="vc-admin-users-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.USERS.TITLE"
    descriptionKey="ADMIN.IA.USERS.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="ADMIN.USERS.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-user-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'users', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredUsers.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.USERS.EMPTY.TITLE"
      descriptionKey="ADMIN.USERS.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredUsers"
      styleClass="Table"
      responsiveLayout="scroll"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.NAME' | translate }}</th>
          <th>{{ 'COMMON.SURNAME' | translate }}</th>
          <th>{{ 'COMMON.EMAIL' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <tr>
          <td>
            <div class="vc-user-name-cell">
              <span>{{ user.name }}</span>
              @if (isAdmin(user)) {
                <span class="vc-user-admin-badge">
                  <i class="fas fa-shield-halved" aria-hidden="true"></i>
                  {{ 'ADMIN.USERS.ADMIN_LABEL' | translate }}
                </span>
              }
            </div>
          </td>
          <td>{{ user.surname }}</td>
          <td>{{ user.email }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'users',
                user.id
              ]"
              [showDelete]="canDelete(user)"
              [deleteDisabled]="!canDelete(user)"
              (delete)="confirmDelete(user)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
